module.exports = __webpack_public_path__ + "img/restaurant_bodyimage08.b49a083c.jpg";